<template>
  <div class="case">
    <div class="container">
      <div>
        <h2>工程案例</h2>
        <h3>case</h3>
      </div>
      <div class="main" data-wow-duration="1s" data-wow-delay=".5s" data-wow-offset="20">
        <div class="left wow fadeInUp" data-wow-duration="1s" data-wow-delay=".5s" data-wow-offset="20">
          <p>{{$AppLang == 'en' ? videoInfo.video_desc_en : videoInfo.video_desc}}</p>
					<div class="more el-icon-right">
						<router-link to="/video">MORE</router-link>
					</div>
        </div>
        <div class="right wow fadeInRight" data-wow-duration="1s" data-wow-delay=".5s" data-wow-offset="20">
          <div class="bg"><img src="../../assets/video-b.png" alt=""></div>
          <div class="video">
            <!-- <video controls :src="videoInfo.url" :poster="videoInfo.pic" height="252px"></video> -->
            <router-link :to="'/video-details?videoId='+videoInfo.id">
							<img :src="videoInfo.pic" alt="">
							<span class="iconfont">&#xe628;</span>
						</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'case',
  data() {
    return{
      videoInfo:[]
    };
  },
	mounted(){
		var options={ live:false};
    var wow=new this.$wow.WOW(options).init();
	},
	created() {
    var that = this;
    that.$api.post(
      'video/homeVideos',
      {},
      function(res) {
        if(res.data.rtnCode == 200){
          that.videoInfo = res.data.data;
        }else{
          alert(res.data.msg);
        }

      }
    );
  }
}
</script>

<style>
.case{
  background: #f2f2f2;
  padding-top: 60px;
  padding-bottom: 60px;
}
.case .main{
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: center;
}
.case .left{
  width: 50%;
}
.case .right{
  width: 50%;
}
.case .left p{
  font-size: 16px;
  color: #999999;
  margin: 15px 0;
}
.case .left{
  box-sizing: border-box;
}

.case i{
  display: none;
  width: 25px;
  padding: 0 5px;
  box-sizing: border-box;
  line-height: 1;
  background: url(../../assets/icon01.png) no-repeat center;
  height: 100%;
  margin-right: 10px;
}
.case span{
  line-height: 1;
}
.case .right{
  position: relative;
}
.case .right .bg{
  width: 100%;
}
.case .right .video{
  width: 74%;
  height: 74%;
  position: absolute;
  top: 49%;
  left: 50%;
  transform: translate(-50%,-50%);
  overflow: hidden;
	cursor: pointer;
}
.case .right .video span{
	color: #cfac70;
	font-size: 54px;
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%,-50%) scale(1.4);
	opacity: 0;
	transition: all .5s ease;
}
.case .right .video:hover span{
	opacity: 1;
	transform: translate(-50%,-50%) scale(1);
}
/* .case .right .video img{
  width: 444px;
  height: 280px;
} */
.case .right img{
  width: 100%;
  display: block;
}
.case .more{
  width: 150px;
  margin-top: 60px;
  border: 1px solid #9e9e9e;
  transition: all .3s ease;
  position: relative;
	display: block;
}
.case .more::before{
  color: #c7c7c7;
  transition: all .3s ease;
  opacity: 0;
  position: absolute;
  top: 50%;
  right: 30%;
  transform: translate(-50%,-50%);
}
.case .more:hover{
  background-color: #333;
}
.case .more:hover::before{
  opacity: 1;
  right: 20%;
}
.case .more:hover a{
  color: #fff;
  transform: translateX(-10px);
}
.case .more a{
  font-size: 14px;
  text-decoration: none;
  color: #666;
  display: block;
  padding: 12px  0;
  transition: all .3s ease;
}
@media (max-width: 992px){
  .case h2{
    font-size: 18px;
  }
  .case .right{
    width: 100%;
		margin-top: 40px;
  }
  .case .left{
    width: 100%;
  }
	.case .more{
		margin: 0 auto;
		margin-top: 60px;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/index/case.vue